import {IconTable, IconDots, IconBrandGoogleFilled, IconChevronRight, IconBrandGithubFilled, IconBrandWindows, IconStackFilled} from '@tabler/icons-react';

import React from 'react';

export default function Integration() {

    const data = [
        {
            id: 1,
            title: 'Google',
            connected_account: '2',
            icon: IconBrandGoogleFilled
        },
        {
            id: 2,
            title: 'Slack',
            connected_account: '2',
            icon: IconStackFilled
        },
        {
            id: 3,
            title: 'Microshoft',
            connected_account: '2',
            icon: IconBrandWindows
        },
        {
            id: 4,
            title: 'Github',
            connected_account: '2',
            icon: IconBrandGithubFilled
        }
    ]

	return (
		<>
			<h1 className="text-3xl font-bold mx-10 mt-5 mb-3">API keys & Integrations</h1>
			<div className='flex flex-col rounded-lg mx-10'>
                {data.map((item, index)=>(

           
                <div className='border rounded-lg p-1 flex items-center space-x-2 bg-white mt-2 hover:bg-gray-200' key={index}>
                   {item.icon ? (
                        React.createElement(item.icon, { size: 16, stroke: 1 }) // Dynamically create the icon component
                    ) : (
                        <div className="w-4 h-4 bg-gray-300" /> // Placeholder if no icon
                    )}
                    <span className='flex-grow overflow-hidden text-ellipsis whitespace-nowrap'>{item.title}</span>
                    <span className='text-slate-500'>{item.connected_account} connected acount</span>
                    <IconChevronRight  size={16} stroke={1} className='text-slate-500'/>
                </div>
                     ))}
			</div>
		</>
	)
}
